import '@stripe-internal/sail/sail.css';

import {Provider} from '@sail/theme-classic';
import {createContext, useContext} from 'react';
import {DefaultTheme, LinkTheme, Theme} from './theme';
import {useNewUniversalHelpDesign} from './FeatureFlagsProvider';
import {LinkAssistantTheme} from './theme/link_assistant';

const ThemeContext = createContext<Theme>(DefaultTheme);

type Props = {
  value?: Theme;
  overrides?: Partial<Theme>;
  children: React.ReactNode;
};

export function ThemeProviderWithoutClassic({
  value = DefaultTheme,
  overrides = {},
  children,
}: Props) {
  const useNewDesign = useNewUniversalHelpDesign();
  let themeValue = value;
  if (themeValue === LinkTheme && useNewDesign) {
    themeValue = LinkAssistantTheme;
  }
  const theme = {...themeValue, ...overrides};

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}

export function ThemeProvider({
  value = DefaultTheme,
  overrides = {},
  children,
}: Props) {
  return (
    <Provider>
      <ThemeProviderWithoutClassic value={value} overrides={overrides}>
        {children}
      </ThemeProviderWithoutClassic>
    </Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
